module.exports = __webpack_public_path__ + "media/images/icons/subtitle-614b146e97410b3fe77b97ec26c64596.svg";